var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.currentUser.roles[0] == 'ROLE_STUDENT')?_c('StudentProfile'):_vm._e(),(_vm.currentUser.roles[0] == 'ROLE_TEACHER')?_c('TeacherProfile'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }